export default __webpack_public_path__ + "static/media/sylabusWhiteIcon.a0dcb7bb.svg";